import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { hydrateBranchData } from 'src/redux/repository/branch/branch-redux';
import { useParams } from 'src/router/hooks';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import { safeDecodePath } from 'src/utils/path';

import { BranchPage } from './components/branch-page';

const BranchDetailRoute = (): JSX.Element => {
  const { ref: branchName } = useParams<{ ref: string }>();
  if (!branchName) {
    throw Error('Branch page route must contain a branch name');
  }

  const dispatch = useDispatch();
  const repositoryFullSlug = useSelector(getCurrentRepositoryFullSlug);
  useEffect(() => {
    if (repositoryFullSlug) {
      dispatch(hydrateBranchData(repositoryFullSlug, branchName));
    }
  }, [repositoryFullSlug, branchName, dispatch]);

  return <BranchPage branchName={safeDecodePath(branchName)} />;
};

export default BranchDetailRoute;
